export default {"src":"/uk/_next/static/media/circle-border.2b63c714.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};